import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { ICbicContentMst } from '../../cbic-content-mst.model';
import {AccordianItemData, IAccordianItemData} from './accordian-data.model'

@Component({
  selector: 'cbic-accordian',
  templateUrl: './accordian.component.html',
})
export class AccordianComponent implements OnInit, OnChanges{
  @Input() data?: ICbicContentMst;
  accordianData: IAccordianItemData[] = new Array<AccordianItemData>();
  
  ngOnInit(){
    this.updateTableInfo(this.data);
  }

  updateTableInfo(content: ICbicContentMst | undefined | null){
    this.accordianData = new Array<AccordianItemData>();
    content?.childContentList?.forEach(item=>{
      this.accordianData?.push({id: item.id ?? 0, title:{En: item.titleEn ?? "", Hi: item.titleHi ?? ""}, data: item});
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const dataChange: SimpleChange = changes["data"];
    if(dataChange && dataChange.previousValue.id !== dataChange.currentValue.id){
      console.log("updating content");
      this.data = dataChange.currentValue;
      this.updateTableInfo(this.data);
    }    
  }
}
